module.exports = __webpack_public_path__ + "img/partner12.930aef83.png";